import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { useSMLRouter, useSMLRoute } from '../../../routing/sml/hooks';
import { SMLRouteNames, SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { isPublicShareRouteName } from '../../music24/assetShare/sharedAssetRoute';
import { assetShareMessages } from '../../music24/assetShare/assetShareMessages';
import { useUserToken } from '../../../redux/slices/appInfo/hooks';
import { trackEvent } from '../../analytics/sml/analytics';
import styles from './PublicModeBanner.module.scss';

const PublicModeBannerComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();
  const route = useSMLRoute();
  const userToken = useUserToken();

  const handleSignUp = useCallback(() => {
    trackEvent('public_share_cta_tapped', {
      ...(route?.[0] === SMLRouteNames.a ? {} : { kind: 'report' }),
      cta: 'startFree',
    });
    router.push(SMLRoutes.auth);
  }, [route, router]);

  const isAuthenticated = userToken !== null && userToken !== undefined;
  const isOnPublicShareRoute = isPublicShareRouteName(route?.[0]);
  // An asset share link (`/app/a/:token`) sells the release kit; the Public Intelligence share
  // links sell the data.
  const isAssetShare = route?.[0] === SMLRouteNames.a;

  if (isAuthenticated || !isOnPublicShareRoute) {
    return null;
  }

  return (
    <div className={styles.banner} data-testid="public-mode-banner">
      <span>
        {isAssetShare
          ? intl.formatMessage(assetShareMessages.bannerText)
          : intl.formatMessage({
              id: 'app.sml.publicMode.banner.text.paidOnly',
              defaultMessage: 'Want to explore the data yourself? Start a 7-day trial',
            })}
      </span>
      <Button color="primary" size="sm" onClick={handleSignUp}>
        {intl.formatMessage({
          id: 'app.sml.publicMode.banner.cta.paidOnly',
          defaultMessage: 'Start a 7-day trial',
        })}
      </Button>
    </div>
  );
};

export const PublicModeBanner = TypedMemo(PublicModeBannerComponent);
